'use client';

import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState
} from 'react';

type UserConsentLoaderContextProps = {
  isUserConsentLoading: boolean;
  setIsUserConsentLoading: (v: boolean) => void;
};

const UserConsentLoaderContext = createContext<UserConsentLoaderContextProps>({
  isUserConsentLoading: false,
  setIsUserConsentLoading: () => null
});
export const useUserConsentLoader = () => useContext(UserConsentLoaderContext);

export const UserConsentLoaderProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const [isUserConsentLoading, setIsUserConsentLoading] = useState(false);
  const userConsent = useMemo(
    () => ({ isUserConsentLoading, setIsUserConsentLoading }),
    [isUserConsentLoading, setIsUserConsentLoading]
  );

  return (
    <UserConsentLoaderContext.Provider value={userConsent}>
      {children}
    </UserConsentLoaderContext.Provider>
  );
};
